import type { SaveShareToUser } from 'src/components/types/types';
import http from '../common/http-auth'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const shareReportToUsers = async (data: SaveShareToUser) => {
    const response = http.post(`/dashboard/saveshareddashboard`, data)
    return response;
}